(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 49536:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(16440);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ InfiniteScrollSpinner; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19989);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30815);
/* harmony import */ var _lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87646);
/* harmony import */ var _lendi_ui_spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7668);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 3rem;\n  text-align: center;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9506d5aa-0"
})(_templateObject(), (0,_lendi_ui_spacing__WEBPACK_IMPORTED_MODULE_3__.my)("sm"));
var InfiniteScrollSpinner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_lendi_ui_spinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
    });
};


/***/ }),

/***/ 49628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_TopArticleCard; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(79894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(30815);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/spacing/dist/spacing.esm.js + 1 modules
var spacing_esm = __webpack_require__(87646);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/typography/dist/typography.esm.js + 2 modules
var typography_esm = __webpack_require__(87856);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/breakpoint/dist/breakpoint.esm.js
var breakpoint_esm = __webpack_require__(66484);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/color/dist/color.esm.js
var color_esm = __webpack_require__(78922);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/grid/dist/grid.esm.js
var grid_esm = __webpack_require__(35633);
// EXTERNAL MODULE: ../node_modules/@lendi-ui/depth/dist/depth.esm.js
var depth_esm = __webpack_require__(83674);
;// CONCATENATED MODULE: ./components/TopArticleCard/index.style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    ",
        "\n    flex-direction: row;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    ",
        "\n    background-position: 100% 50%;\n    border-radius: 6px;\n    height: 320px;\n    flex-shrink: 0;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  width: 100%;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: 50% 50%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: none;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  border-bottom: 1px solid ",
        ";\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  text-transform: uppercase;\n  cursor: pointer;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  text-decoration: none;\n  :active {\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}







var Article = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-e434b105-0"
})(_templateObject1(), (0,breakpoint_esm/* gte */.eg)("desktop")(_templateObject(), (0,spacing_esm.my)("xl"), (0,spacing_esm.px)("xxs")));
var FigureLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-e434b105-1"
})(_templateObject3(), (0,breakpoint_esm/* gte */.eg)("desktop")(_templateObject2(), (0,grid_esm/* unit */.bf)({
    size: 0.4
}), (0,depth_esm/* depth */.Y)(1)));
var Figure = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    componentId: "sc-e434b105-2"
})(_templateObject4(), (0,spacing_esm.m)("nil"));
var Summary = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-e434b105-3"
})(_templateObject6(), (0,spacing_esm.mx)({
    mobile: "sm",
    desktop: "lg"
}), (0,spacing_esm.my)("sm"), (0,color_esm/* color */.$)("shade.100"), (0,breakpoint_esm/* gte */.eg)("desktop")(_templateObject5()));
var CategoryLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-e434b105-4"
})(_templateObject7());
var Category = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-e434b105-5"
})(_templateObject8(), (0,typography_esm/* body */.d1)({
    size: "xs",
    color: "primary.500"
}), (0,spacing_esm.m)("nil"));
var Alink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-e434b105-6"
})(_templateObject9(), (0,typography_esm/* link */.p4)(), (0,color_esm.fg)("shade.700"));
var Heading = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-e434b105-7"
})(_templateObject10(), (0,typography_esm/* heading */.nP)({
    size: "md"
}), (0,spacing_esm.mt)("sm"), (0,spacing_esm.mb)("xs"));
var BlogInfo = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-e434b105-8"
})(_templateObject11(), (0,typography_esm/* body */.d1)({
    size: "xs"
}), (0,color_esm.fg)("shade.500"));
var Author = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e434b105-9"
})(_templateObject12());
var AuthorInfo = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e434b105-10"
})(_templateObject13(), (0,spacing_esm.mr)("xxxs"));
var ReadTimeInfo = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e434b105-11"
})(_templateObject14(), (0,spacing_esm.ml)("xxxs"));
var Overview = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-e434b105-12"
})(_templateObject15(), (0,typography_esm/* body */.d1)({
    size: "md"
}), (0,spacing_esm.my)("sm"));

// EXTERNAL MODULE: ./utils/index.ts + 13 modules
var utils = __webpack_require__(54422);
;// CONCATENATED MODULE: ./components/TopArticleCard/index.tsx





var TopArticleCard = function(param) {
    var article = param.article;
    if (!article) {
        return null;
    }
    var primaryImage = article.primaryImage, slug = article.slug, title = article.title, _category = article.category, category = _category.name, categorySlug = _category.slug, author = article.author, published = article.published, formattedPublished = article.formattedPublished, readTime = article.readTime, shortOverview = article.shortOverview;
    var categoryLink = "/?category=".concat(categorySlug);
    var categoryLinkAs = "/inspire/category/".concat(categorySlug);
    var articleLink = "/article?category=".concat(categorySlug, "&slug=").concat(slug);
    var articleLinkAs = "/inspire/".concat(categorySlug, "/").concat(slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Article, {
        itemScope: true,
        itemType: "http://schema.org/Article",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                itemProp: "datePublished",
                content: published
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                itemProp: "url",
                content: (0,utils/* articleUrl */.MG)(article)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                itemProp: "mainEntityOfPage",
                content: (0,utils/* articleUrl */.MG)(article)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                itemProp: "name",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                itemProp: "headline",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                as: articleLinkAs,
                href: articleLink,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FigureLink, {
                    target: "_blank",
                    onClick: function() {
                        (0,utils/* eventTracking */.fn)("above-fold", "navigate", "Primary Image (Desktop)");
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Figure, {
                        style: {
                            backgroundImage: "url(".concat(primaryImage, ")")
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Summary, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        as: categoryLinkAs,
                        href: categoryLink,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryLink, {
                            target: "_blank",
                            onClick: function() {
                                (0,utils/* eventTracking */.fn)("above-fold", "navigate", category);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Category, {
                                children: category
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        as: articleLinkAs,
                        href: articleLink,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alink, {
                            target: "_blank",
                            onClick: function() {
                                (0,utils/* eventTracking */.fn)("above-fold", "navigate", title);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                children: title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlogInfo, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthorInfo, {
                                children: [
                                    "By ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Author, {
                                        itemProp: "author",
                                        children: author
                                    }),
                                    ","
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                dateTime: published,
                                itemProp: "datePublished",
                                children: formattedPublished
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReadTimeInfo, {
                                children: [
                                    "| ",
                                    readTime,
                                    " min read"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Overview, {
                        children: shortOverview
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_TopArticleCard = (TopArticleCard);


/***/ }),

/***/ 16440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54300);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(24364);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70619);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(3204);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(83490);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(48482);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88038);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_infinite_scroller__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43674);
/* harmony import */ var react_infinite_scroller__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lendi_ui_container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43151);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54422);
/* harmony import */ var _components_Article_index_style__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78934);
/* harmony import */ var _components_InfiniteScrollSpinner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5031);
/* harmony import */ var _components_TopArticleCard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49628);
/* harmony import */ var _components_ArticleCard__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95622);
/* harmony import */ var _datadog_browser_rum__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38068);


















var PAGE_SIZE = 10;
var META_DEFAULTS = {
    title: "Inspire",
    description: "Get the latest home loan, property and design news tips and advice from our team of industry experts.",
    image: "https://prodassets.lendi.com.au/lendi_logo_white_bg.jpg"
};
var articleIds = [];
function filterExistingArticles(newArticles) {
    var filteredArticles = newArticles.filter(function(param) {
        var id = param.id;
        if (articleIds.indexOf(id) !== -1) {
            return false;
        }
        // Just in case, let's assume there might be some dups in the newArticles as well.
        articleIds.push(id);
        return true;
    });
    return filteredArticles;
}
var IndexPage = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(IndexPage, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(IndexPage);
    function IndexPage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(this, IndexPage);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            articles: _this.props.articles || [],
            offset: 1,
            hasMore: _this.props.articles.length === PAGE_SIZE
        };
        var _this1 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_this);
        _this.componentDidUpdate = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(prevProps) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                    if (_this1.props.category !== prevProps.category) {
                        _this1.setState({
                            articles: _this1.props.articles || [],
                            offset: 1,
                            hasMore: _this1.props.articles.length === PAGE_SIZE
                        });
                    }
                    return [
                        2
                    ];
                });
            });
            return function(prevProps) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_this);
        _this.lazyLoading = /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function() {
            var articles;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .loadArticles */ .nw)({
                                category: _this2.props.category,
                                limit: PAGE_SIZE,
                                skip: _this2.state.offset * PAGE_SIZE
                            })
                        ];
                    case 1:
                        articles = _state.sent();
                        _this2.setState({
                            articles: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_this2.state.articles).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(filterExistingArticles(articles))),
                            offset: _this2.state.offset + 1,
                            hasMore: articles.length === PAGE_SIZE
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _this;
    }
    var _proto = IndexPage.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _articleIds;
        (_articleIds = articleIds).push.apply(_articleIds, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(this.state.articles.map(function(param) {
            var id = param.id;
            return id;
        })));
    };
    _proto.render = function render() {
        var category = this.props.category;
        var _state = this.state, articles = _state.articles, hasMore = _state.hasMore;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                            children: [
                                category && "".concat(category.name, " - "),
                                META_DEFAULTS.title,
                                " - Lendi"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "description",
                            content: category ? category.description : META_DEFAULTS.description
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:type",
                            content: "article"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:title",
                            content: category ? category.name : META_DEFAULTS.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:description",
                            content: category ? category.description : META_DEFAULTS.description
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:image",
                            content: META_DEFAULTS.image
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:url",
                            content: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .categoryUrl */ .xf)(category)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:title",
                            content: category ? category.name : META_DEFAULTS.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:description",
                            content: category ? category.description : META_DEFAULTS.description
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:image",
                            content: META_DEFAULTS.image
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:creator",
                            content: "@lendiau"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                            rel: "canonical",
                            href: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .categoryUrl */ .xf)(category)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lendi_ui_container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((react_infinite_scroller__WEBPACK_IMPORTED_MODULE_3___default()), {
                        pageStart: 0,
                        loadMore: this.lazyLoading,
                        hasMore: hasMore,
                        loader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_InfiniteScrollSpinner__WEBPACK_IMPORTED_MODULE_7__/* .InfiniteScrollSpinner */ .d, {}, 0),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TopArticleCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                article: articles[0]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Article_index_style__WEBPACK_IMPORTED_MODULE_6__/* .ArticlesContainer */ .S5, {
                                children: articles.map(function(article, index) {
                                    return index > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ArticleCard__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        article: article,
                                        showSummary: true
                                    }, article.id);
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        _datadog_browser_rum__WEBPACK_IMPORTED_MODULE_10__/* .datadogRum.addError */ .v.addError(error, errorInfo);
    };
    return IndexPage;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [683,328,774,888,179], function() { return __webpack_exec__(49536); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);